import React from 'react'
import { Route, Routes } from 'react-router-dom'

const Call_TechPage = React.lazy(
  () => import('@/features/chamados/pages/chamado-relatorio-tecnico'),
)
const Call_DetailsPage = React.lazy(
  () => import('@/features/chamados/pages/chamado-detalhar'),
)
const Call_HeaderOutlet = React.lazy(
  () => import('@/features/chamados/layouts/chamado-detalhar-layout'),
)
const CallProduct_ListPage = React.lazy(
  () => import('@/features/chamados/pages/chamado-itens'),
)

export default function Component() {
  return (
    <Routes>
      <Route path=":callId" element={<Call_HeaderOutlet />}>
        <Route path="detalhes" element={<Call_DetailsPage />} />
        <Route path="tecnico" element={<Call_TechPage />} />
        <Route path="produtos" element={<CallProduct_ListPage />} />
      </Route>
    </Routes>
  )
}
